import { DataType } from '@common/enums/data-type';
import { KnownPropertyTypes } from '@common/enums/known-property-types';
import { IServiceCollectionRecord } from '@common/interfaces/i-service-collection-record';
import { IServiceCollectionScript } from '@common/interfaces/i-service-collection-script';

import { AbstractServiceRecord } from './abstract-service-record';
import { ServiceCollectionFactory } from './service-collection-factory';

const metaData = {
    HasPendingChanges: DataType.BOOL,
    LTTRecording: DataType.BOOL,
    OnAir: DataType.BOOL,
    SuspendRowFlashing: DataType.BOOL,
    TimeFormat: DataType.NUMBER,
    UpdatesSuspended: DataType.BOOL,
};

KnownPropertyTypes.setFor(metaData);

export class ServiceCollectionRecord extends AbstractServiceRecord implements IServiceCollectionRecord {
    public CollectionScripts: Array<IServiceCollectionScript>;
    public HasPendingChanges?: boolean;
    public LTTRecording?: boolean;
    public OnAir?: boolean;
    public SuspendRowFlashing?: boolean;
    public TimeFormat?: number;
    public UpdatesSuspended?: boolean;
    public RemovedScripts?: Array<string>;
    public TimingObj: {
        FrontOverUnder: string;
        IsROCountDown: boolean;
        IsROTimeEstimated: boolean;
        IsSegCountDown: boolean;
        IsStoryCountDown: boolean;
        IsTiming: boolean;
        OverUnder: string;
        ProgramCountDown: string;
        SegmentCountDown: string;
        SegmentCountUp: string;
        StoryCountDown: string;
        TotalCumeTime: number;
        TotalOverUnderTime: number;
    };
    public Stories?: Array<IServiceCollectionScript>;

    public getOwnMetaData(): { [id: string]: number } {
        const objectKeys = Object.keys(this);
        const ret = {};
        for (const prop of objectKeys) {
            if (metaData[prop]) ret[prop] = metaData[prop];
        }
        return ret;
    }

    public getMetaData(): { [id: string]: number } {
        const ret = this.getOwnMetaData();
        const parentMetaData = super.getMetaData();

        // merge
        for (const p in parentMetaData) {
            if (!ret[p]) ret[p] = parentMetaData[p];
        }

        return ret;
    }

    public getRawValue(field: string): any {
        if (this.getOwnMetaData()[field]) {
            return this[field];
        }
        return super.getRawValue(field);
    }

    public static instance(data: any): ServiceCollectionRecord {
        const ret: ServiceCollectionRecord = Object.assign(ServiceCollectionFactory.newServiceCollectionRecord(), data);
        if (ret.CollectionScripts) {
            for (const i in ret.CollectionScripts) {
                ret.CollectionScripts[i] = Object.assign(ServiceCollectionFactory.newServiceCollectionScript(), ret.CollectionScripts[i]);
                ret.CollectionScripts[i].instantiateChildren();
            }
            ret.instantiateChildren();
        }
        return ret;
    }
}

ServiceCollectionFactory.newServiceCollectionRecord = () => new ServiceCollectionRecord();
